import {
  ArbeitszeitArbeitszeitantragStatus,
  GetToDosQuery,
} from '@/gql/graphql';
import {
  Antrag,
  AntragZeitstempel,
} from '../../components/Table/ToDoTable/entities/Antrag';
import { Zeitstempel } from '../../components/Table/ToDoTable/entities/Zeitstempel';
import dayjs from 'dayjs';

export function getToDoAntraege({ data }: { data: GetToDosQuery }) {
  const toDoAntraege = data.toDos
    .filter((toDo) => toDo.__typename === 'ToDoAntraege')
    // oxlint-disable-next-line complexity
    .map((toDoAntrag) => {
      const newToDoAntrag = new Antrag({
        id: toDoAntrag.antragId,
        beginn: toDoAntrag.antragBeginn
          ? new AntragZeitstempel({
              zeitstempel: new Zeitstempel({
                abweichung: 0,
                zeitpunkt: dayjs(toDoAntrag.antragBeginn.zeitstempel.zeitpunkt),
              }),
              changeRequested: toDoAntrag.antragBeginn.changeRequested,
            })
          : null,
        ende: toDoAntrag.antragEnde
          ? new AntragZeitstempel({
              zeitstempel: new Zeitstempel({
                abweichung: 0,
                zeitpunkt: dayjs(toDoAntrag.antragEnde.zeitstempel.zeitpunkt),
              }),
              changeRequested: toDoAntrag.antragEnde.changeRequested,
            })
          : null,
        mitarbeiter: {
          id: toDoAntrag.mitarbeiter.id,
          vorname: toDoAntrag.mitarbeiter.vorname,
          nachname: toDoAntrag.mitarbeiter.nachname,
          imgUrl: toDoAntrag.mitarbeiter.bildUrl,
          arbeitsbereich: {
            id: toDoAntrag.antragArbeitsbereich?.id,
            name: toDoAntrag.antragArbeitsbereich?.name,
            markierung: toDoAntrag.antragArbeitsbereich?.markierung,
          },
          extern: toDoAntrag.mitarbeiter.extern,
        },
        arbeitsbereich: {
          id: toDoAntrag.antragArbeitsbereich?.id,
          name: toDoAntrag.antragArbeitsbereich?.name,
          markierung: toDoAntrag.antragArbeitsbereich?.markierung,
          abteilungen: toDoAntrag.antragArbeitsbereich?.abteilungen.map(
            (abteilung) => {
              return {
                id: abteilung.id,
              };
            },
          ),
        },
        status: toDoAntrag.status as ArbeitszeitArbeitszeitantragStatus,
        offen: toDoAntrag.offen,
        bemerkungAntragsteller: toDoAntrag.bemerkungAntragsteller,
        bemerkungVorgesetzter: toDoAntrag.bemerkungVorgesetzter,
        datum: toDoAntrag.datum,
        arbeitszeitId: toDoAntrag.arbeitszeitId,
        erstellungsdatum: toDoAntrag.erstellungsdatum,
        aenderungsdatum: toDoAntrag.aenderungsdatum,
      });
      return newToDoAntrag;
    });

  return toDoAntraege;
}
